export class GetBackupPolicyResponse {
    'backupPolicy';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicy",
            "baseName": "backupPolicy",
            "type": "BackupPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetBackupPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
